import InputBase from "./InputBase";

const TextInput = (props) => <InputBase {...props} type="text" />;

export default TextInput;
